import { render, staticRenderFns } from "./ScreenSize.vue?vue&type=template&id=199f67a6&scoped=true&"
import script from "./ScreenSize.vue?vue&type=script&lang=js&"
export * from "./ScreenSize.vue?vue&type=script&lang=js&"
import style0 from "./ScreenSize.vue?vue&type=style&index=0&id=199f67a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199f67a6",
  null
  
)

export default component.exports